var selectProfile=document.getElementById('selectProfile') || null;

if(selectProfile) {
    document.addEventListener('DOMContentLoaded', function () {
        var itemNav = document.querySelector('.list-group-item.active-profile');
        var selectProfile = document.getElementById('selectProfile');
        var collapse = document.getElementById('subprofile');
        var arrowProfile = document.getElementById('arrow-profile');
        if (itemNav) {
            selectProfile.classList.add('active');
            arrowProfile.classList.remove('fa-angle-right');
            arrowProfile.classList.add('fa-angle-down');
            collapse.classList.add('show');
        }
    });

    selectProfile.addEventListener('click', function (ev) {
        var itemNav = document.querySelector('.list-group-item.active');
        var selectProfile = document.getElementById('selectProfile');
        var arrowProfile = document.getElementById('arrow-profile');
        if (itemNav) {
            itemNav.classList.remove('active');
        }

        if (arrowProfile.classList[2] == 'fa-angle-right') {
            arrowProfile.classList.remove('fa-angle-right');
            arrowProfile.classList.add('fa-angle-down');
        } else {
            arrowProfile.classList.remove('fa-angle-down');
            arrowProfile.classList.add('fa-angle-right');
        }
    });
}
$('.open-sidebar').click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('.sidebar').toggleClass("open");
    $('#overlay').show();
});

$('.close-sidebar').click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('.sidebar').removeClass("open");
    $('#overlay').hide();
});

$('body,html').click(function(event){
    $('.sidebar').removeClass('open');
    $('#overlay').hide();
});
